import { UserType } from '@/constants';

export interface IToolUserPermissionRow {
    typeId: UserType | null;
    ownerId: number | null;
    openedByToolUserId: number | null;
    deletedAt: string | null;
}

export function canEditToolUserRow(item: IToolUserPermissionRow, sessionType: UserType | null, myToolUserId: number | null, isRoot: boolean): boolean {
    if (isRoot) return true;
    if (sessionType == null) return false;
    switch (item.typeId) {
        case UserType.Admin:
        case UserType.Company:
            return sessionType === UserType.Admin;
        case UserType.Agent:
        case UserType.AgentView:
            return sessionType === UserType.Admin || (sessionType === UserType.Company && myToolUserId != null && myToolUserId === item.ownerId);
        case UserType.Player: {
            const agentScopeId = item.ownerId ?? item.openedByToolUserId;
            return (
                sessionType === UserType.Admin ||
                sessionType === UserType.Company ||
                ((sessionType === UserType.Agent || sessionType === UserType.AgentView) && myToolUserId != null && myToolUserId === agentScopeId)
            );
        }
        default:
            return false;
    }
}

export function canDeleteToolUserRow(item: IToolUserPermissionRow, sessionType: UserType | null, myToolUserId: number | null, isRoot: boolean): boolean {
    if (item.deletedAt) return false;
    return canEditToolUserRow(item, sessionType, myToolUserId, isRoot);
}
